import { css } from '@emotion/react';

const globalStyles = css`
  :root {
    font-size: 16px;
    height: 100%;
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0px;
    height: 100%;
  }

  #root {
    width: 580px;
    height: 720px;
    position: relative;
    overflow: auto;
  }
`;

export default globalStyles;
